import React from 'react';
import Backend from '../../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import { Row, Col, Form } from 'reactstrap';
import { Formik } from 'formik';
import { validationSchema } from './validation';
import { CustomFormInput, CustomCheckBox } from '../../../../UI/CustomForm';
import { Alert, Button, Dropdown, Input } from '../../../../UI/Common';
import { cloneDeep } from 'lodash';
import helper from '../../../../../utils/helper';
import PasswordConfirmation from '../../../../UI/PasswordConfirmation';
import ReactSelect from '../../../../UI/ReactSelect';

const hrStyle = {
  height: 5,
  backgroundColor: 'rgb(0 0 0 / 10%)',
};
const locale = [
  { label: 'English', value: 'en_US' },
  { label: 'Espanol', value: 'es' },
];
//prettier-ignore
const uselessTimezones=["UTC-09","UTC-08","UTC-02","Coordinated Universal Time","UTC+12","UTC+13"]
const DepartmentSettingsPage = (props) => {
  const { t, isSubmitting, maps, getDepartmentError, form } = props;
  const [openModal, setOpenModal] = React.useState(false);
  const [logo, updateLogo] = React.useState(null);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onDepartmentSettings(values, logo);
    }
  }
  const _maps = cloneDeep(maps);
  _maps.unshift('<No Map Selected>');
  if (Object.keys(getDepartmentError).length) {
    return (
      <Backend>
        <div className="content-inner">
          <h1>{t('This department is unavailable')}</h1>
        </div>
      </Backend>
    );
  }
  function getTimeZoneList() {
    if (props.timezones.length) {
      return props.timezones.filter(
        (tz) => !uselessTimezones.includes(tz.standardName),
      );
    }
    return props.timezones;
  }
  function onUploadLogo(e) {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      function () {
        let src = reader.result;
        updateLogo(src);
        props.onDepartmentLogoChanged();
      },
      false,
    );
    if (file) {
      reader.readAsDataURL(file);
    }
  }

  return (
    <Backend title={`Department Setting: ${form.name}`}>
      <div className="content-inner">
        <Formik
          enableReinitialize
          initialValues={{ ...form, PasswordRequiredUniqueChars: 1 }}
          validationSchema={validationSchema}
          onSubmit={(values) => onSubmit(values)}
        >
          {({
            values,
            handleChange,
            setFieldValue,
            errors,
            touched,
            handleSubmit,
          }) => {
            return (
              <Form>
                <PasswordConfirmation
                  isOpen={openModal}
                  onCancel={() => setOpenModal(false)}
                  onConfirm={() => {
                    setOpenModal(false);
                    props.onDepartmentSettings(values);
                  }}
                />
                <Row>
                  <Col>
                    <Input
                      required
                      id="name"
                      label="Name"
                      onChange={handleChange('name')}
                      value={values.name}
                      invalid={touched.name}
                      error={errors.name}
                    />
                    <CustomFormInput
                      label="System Name"
                      id="SystemName"
                      onChange={handleChange('SystemName')}
                      value={values.SystemName}
                    />
                    <Row>
                      <Col>
                        <div className="position-relative">
                          <Button
                            classes="p-0 d-flex w-100 justify-content-center align-items-center"
                            style={{ lineHeight: 1 }}
                          >
                            {t('Upload Logo')}
                          </Button>
                          <input
                            type="file"
                            accept="image/*"
                            onChange={onUploadLogo}
                            className="position-absolute h-100 w-100"
                            style={{ top: 0, opacity: 0 }}
                          />
                        </div>
                      </Col>
                      <Col>
                        <Button
                          classes="p-0 d-flex w-100 justify-content-center align-items-center"
                          style={{ lineHeight: 1 }}
                          onClick={() => {
                            updateLogo(null);
                            props.onDepartmentLogoChanged();
                          }}
                        >
                          {t('Remove Logo')}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Input
                      id="description"
                      label="Description"
                      onChange={handleChange('description')}
                      value={values.description}
                      invalid={errors.description && touched.description}
                      error={errors.description}
                    />
                    <Row>
                      <Col>
                        <ReactSelect
                          label="Main Map"
                          options={_maps}
                          value={values.MainMapName}
                          onChange={(obj) => {
                            setFieldValue('MainMapName', obj.value);
                          }}
                        />
                      </Col>
                      <Col>
                        <ReactSelect
                          label="Secondary Map"
                          options={_maps}
                          value={values.SecondaryMapName}
                          onChange={(obj) => {
                            setFieldValue('SecondaryMapName', obj.value);
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <hr style={hrStyle} />
                <Row>
                  <Col>
                    <CustomCheckBox
                      id="ProcessAlarms"
                      label="Process Alarms"
                      checked={values.ProcessAlarms}
                      onChange={(isCheck) =>
                        setFieldValue('ProcessAlarms', isCheck)
                      }
                    />
                    <CustomCheckBox
                      id="SendAlerts"
                      label="Send Alerts"
                      checked={values.SendAlerts}
                      onChange={(isCheck) =>
                        setFieldValue('SendAlerts', isCheck)
                      }
                    />
                    <CustomCheckBox
                      id="RequireAlarmAck"
                      label="Require Alarm Acknowledgement"
                      checked={values.RequireAlarmAck}
                      onChange={(isCheck) =>
                        setFieldValue('RequireAlarmAck', isCheck)
                      }
                    />
                    <CustomCheckBox
                      id="RequireAssignableCauses"
                      label="Require Assignable Causes"
                      checked={values.RequireAssignableCauses}
                      onChange={(isCheck) =>
                        setFieldValue('RequireAssignableCauses', isCheck)
                      }
                    />
                  </Col>
                  <Col>
                    <CustomCheckBox
                      id="LogSensorData"
                      label="Log Sensor Data"
                      checked={values.LogSensorData}
                      onChange={(isCheck) =>
                        setFieldValue('LogSensorData', isCheck)
                      }
                    />
                    <CustomCheckBox
                      id="WarningDelay"
                      label="Warnings Delay"
                      checked={values.WarningDelay}
                      onChange={(isCheck) =>
                        setFieldValue('WarningDelay', isCheck)
                      }
                    />
                    <CustomCheckBox
                      id="RequireConfirmation"
                      label="Require Confirmation"
                      checked={values.RequireConfirmation}
                      onChange={(isCheck) =>
                        setFieldValue('RequireConfirmation', isCheck)
                      }
                    />
                  </Col>
                </Row>
                <hr style={hrStyle} />
                <Row>
                  <Col>
                    <CustomFormInput
                      label="Password Expiration (days)"
                      id="PasswordExpirationDays"
                      onChange={handleChange('PasswordExpirationDays')}
                      invalid={
                        errors.PasswordExpirationDays &&
                        touched.PasswordExpirationDays
                      }
                      value={values.PasswordExpirationDays}
                      error={errors.PasswordExpirationDays}
                    />
                    <CustomCheckBox
                      id="PasswordRequireDigit"
                      label="Password Require Digit"
                      checked={values.PasswordRequireDigit}
                      onChange={(isCheck) =>
                        setFieldValue('PasswordRequireDigit', isCheck)
                      }
                    />
                    <CustomFormInput
                      label="Password Require Length"
                      id="PasswordRequiredLength"
                      onChange={handleChange('PasswordRequiredLength')}
                      invalid={
                        errors.PasswordRequiredLength &&
                        touched.PasswordRequiredLength
                      }
                      value={values.PasswordRequiredLength}
                      error={errors.PasswordRequiredLength}
                    />
                    {/* <CustomFormInput
                      label="Password Require Unique Characters"
                      id="PasswordRequiredUniqueChars"
                      onChange={handleChange('PasswordRequiredUniqueChars')}
                      invalid={
                        errors.PasswordRequiredUniqueChars &&
                        touched.PasswordRequiredUniqueChars
                      }
                      value={values.PasswordRequiredUniqueChars}
                      error={errors.PasswordRequiredUniqueChars}
                    /> */}
                    <CustomFormInput
                      label="Password History Retention"
                      id="PasswordHistoryThreshold"
                      onChange={handleChange('PasswordHistoryThreshold')}
                      invalid={
                        errors.PasswordHistoryThreshold &&
                        touched.PasswordHistoryThreshold
                      }
                      value={values.PasswordHistoryThreshold}
                      error={errors.PasswordHistoryThreshold}
                    />
                  </Col>
                  <Col>
                    <CustomFormInput
                      label="Autolock after days of inactivity"
                      id="Autolock"
                      onChange={handleChange('Autolock')}
                      invalid={errors.Autolock && touched.Autolock}
                      value={values.Autolock}
                      error={errors.Autolock}
                    />
                    <CustomFormInput
                      label="Session Timeout (min)"
                      id="SessionTimeoutMinutes"
                      onChange={handleChange('SessionTimeoutMinutes')}
                      invalid={
                        errors.SessionTimeoutMinutes &&
                        touched.SessionTimeoutMinutes
                      }
                      value={values.SessionTimeoutMinutes}
                      error={errors.SessionTimeoutMinutes}
                    />
                    <CustomCheckBox
                      id="PasswordRequireLowercase"
                      label="Password Require Lower Case"
                      checked={values.PasswordRequireLowercase}
                      onChange={(isCheck) =>
                        setFieldValue('PasswordRequireLowercase', isCheck)
                      }
                    />
                    <CustomCheckBox
                      id="PasswordRequireUppercase"
                      label="Password Require Upper Case"
                      checked={values.PasswordRequireUppercase}
                      onChange={(isCheck) =>
                        setFieldValue('PasswordRequireUppercase', isCheck)
                      }
                    />
                    <CustomCheckBox
                      id="PasswordRequireNonAlphanumeric"
                      label="Password Require Non Alphanumeric"
                      checked={values.PasswordRequireNonAlphanumeric}
                      onChange={(isCheck) =>
                        setFieldValue('PasswordRequireNonAlphanumeric', isCheck)
                      }
                    />
                  </Col>
                </Row>
                <hr style={hrStyle} />
                <Row>
                  <Col>
                    <CustomFormInput
                      label="Values Refresh Rate (sec)"
                      id="ValueRefreshRateSec"
                      onChange={handleChange('ValueRefreshRateSec')}
                      invalid={
                        errors.ValueRefreshRateSec &&
                        touched.ValueRefreshRateSec
                      }
                      value={values.ValueRefreshRateSec}
                      error={errors.ValueRefreshRateSec}
                    />
                    {/* <CustomFormInput
                      label="Time Zone Offset"
                      id="TimeZoneOffset"
                      onChange={handleChange('TimeZoneOffset')}
                      invalid={errors.TimeZoneOffset && touched.TimeZoneOffset}
                      value={values.TimeZoneOffset}
                      error={errors.TimeZoneOffset}
                    />
                    <CustomFormInput
                      label="Daylight Savings Time Adjustment"
                      id="DSTOffset"
                      onChange={handleChange('DSTOffset')}
                      invalid={errors.DSTOffset && touched.DSTOffset}
                      value={values.DSTOffset}
                      error={errors.DSTOffset}
                    /> */}
                    <ReactSelect
                      label="Timezone"
                      options={getTimeZoneList()}
                      value={values.TimezoneName}
                      onChange={(obj) => {
                        setFieldValue('TimezoneName', obj.value);
                      }}
                      valueKey="id"
                      labelKey="displayName"
                    />
                    <CustomFormInput
                      label="Remotes Comm. Loss Timeout (min)"
                      id="RemoteCommLossTimeout"
                      onChange={handleChange('RemoteCommLossTimeout')}
                      invalid={
                        errors.RemoteCommLossTimeout &&
                        touched.RemoteCommLossTimeout
                      }
                      value={values.RemoteCommLossTimeout}
                      error={errors.RemoteCommLossTimeout}
                    />
                  </Col>
                  <Col>
                    <CustomFormInput
                      label="Trend Chart Default Period (hrs)"
                      id="TrendChartDefaultPeriodHours"
                      onChange={handleChange('TrendChartDefaultPeriodHours')}
                      invalid={
                        errors.TrendChartDefaultPeriodHours &&
                        touched.TrendChartDefaultPeriodHours
                      }
                      value={values.TrendChartDefaultPeriodHours}
                      error={errors.TrendChartDefaultPeriodHours}
                    />
                    <CustomFormInput
                      label="Local Database Storage Time Limit (days)"
                      id="LocalDatabaseStorageDays"
                      onChange={handleChange('LocalDatabaseStorageDays')}
                      invalid={
                        errors.LocalDatabaseStorageDays &&
                        touched.LocalDatabaseStorageDays
                      }
                      value={values.LocalDatabaseStorageDays}
                      error={errors.LocalDatabaseStorageDays}
                    />
                    <CustomFormInput
                      label="Archive Database Storage Time Limit"
                      id="ArchiveStorageDays"
                      onChange={handleChange('ArchiveStorageDays')}
                      invalid={
                        errors.ArchiveStorageDays && touched.ArchiveStorageDays
                      }
                      value={values.ArchiveStorageDays}
                      error={errors.ArchiveStorageDays}
                    />
                    <CustomFormInput
                      label="Custom Reports Directory Name"
                      id="CustomReportsDirectory"
                      onChange={handleChange('CustomReportsDirectory')}
                      value={values.CustomReportsDirectory}
                    />
                  </Col>
                </Row>
                <hr style={hrStyle} />
                <Row>
                  <Col>
                    <CustomFormInput
                      label="Alert Contact List"
                      id="AlertContactList"
                      onChange={handleChange('AlertContactList')}
                      value={values.AlertContactList}
                    />
                  </Col>
                  <Col>
                    <CustomFormInput
                      label="Test Alert Schedule"
                      id="TestAlertSchedule"
                      onChange={handleChange('TestAlertSchedule')}
                      value={values.TestAlertSchedule}
                    />
                  </Col>
                </Row>
                <Alert.Error text={props.errors} />
                <Button
                  id="btn-department-settings"
                  classes="mt-20"
                  loading={isSubmitting}
                  onClick={handleSubmit}
                >
                  <i className="md-icon">done</i>
                  {t('Save')}
                </Button>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(DepartmentSettingsPage);
